import fileDownload from "js-file-download";
import { workflowInstance_V2, workflowInstance_V3 } from "../services/api";
import { FILES_FORMAT } from "./fileFormats";

export const downloadAndSaveFile = (
  endpoint: string,
  fileName: string,
  format: string,
  params?: Record<string, string | undefined>,
  version = 2,
) => {
  const formatObj = FILES_FORMAT.find((item) => item.id === format);

  (version === 2 ? workflowInstance_V2 : workflowInstance_V3)
    .get(endpoint, {
      responseType: "blob",
      params: { format: format, ...params },
    })
    .then((response) => {
      const aBlob = new Blob([response.data], {
        type: formatObj?.mimetype,
      });
      fileDownload(aBlob, fileName, formatObj?.mimetype);
    });
};
